import TrustSubpageView from 'views/trust/subpage'
import {
	getStaticPaths,
	getStaticProps,
} from 'views/trust/subpage-overview/server'

export default TrustSubpageView
export { getStaticPaths, getStaticProps }
